import { CanActivateFn } from '@angular/router';
import { roleGuard } from './role.guard';

/**
 * Guard для защиты страниц поставщика
 * Доступ только для пользователей с ролью quota_supplier
 */
export const supplierGuard: CanActivateFn = roleGuard(['quota_supplier'], '/');
